var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssiduidade(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 137,
    viewBox: "0 0 136 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 0.5C30.4471 0.5 0 30.9471 0 68.5C0 106.053 30.4471 136.5 68 136.5C105.553 136.5 136 106.053 136 68.5C136 30.9471 105.553 0.5 68 0.5ZM68 127.012C35.6868 127.012 9.48837 100.813 9.48837 68.5C9.48837 36.1868 35.6868 9.98837 68 9.98837C100.313 9.98837 126.512 36.1868 126.512 68.5C126.512 100.813 100.313 127.012 68 127.012Z",
    fill: "#F9A003"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7441 28.5006V19.0122H63.2558V28.5006H72.7441Z",
    fill: "#F9A003"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7441 117.986V108.498H63.2558V117.986H72.7441Z",
    fill: "#F9A003"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0117 63.7554H18.5234V73.2437H28.0117V63.7554Z",
    fill: "#F9A003"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117.477 63.7554H107.988V73.2437H117.477V63.7554Z",
    fill: "#F9A003"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3611 93.4216L29.6519 100.131L36.3611 106.84L43.0704 100.131L36.3611 93.4216Z",
    fill: "#F9A003"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6425 30.1589L92.9332 36.8682L99.6425 43.5775L106.352 36.8682L99.6425 30.1589Z",
    fill: "#F9A003"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9216 100.127L99.6309 106.836L106.34 100.127L99.6309 93.4178L92.9216 100.127Z",
    fill: "#F9A003"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6597 36.8683L36.369 43.5776L43.0783 36.8683L36.369 30.1591L29.6597 36.8683Z",
    fill: "#F9A003"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8592 71.7681C84.6995 69.4066 81.853 68.4366 79.502 69.5963L71.2893 73.6552V51.1045C71.2893 48.4794 69.1702 46.3604 66.5451 46.3604C63.92 46.3604 61.8009 48.4794 61.8009 51.1045V76.6283C61.8009 80.8664 65.2378 84.3138 69.4865 84.3138C70.6778 84.3138 71.848 84.0397 72.9128 83.5126L83.7296 78.1253C86.0701 76.9551 87.0294 74.1191 85.8697 71.7786L85.8592 71.7681Z",
    fill: "#F9A003"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssiduidade);
export default __webpack_public_path__ + "static/media/assiduidade.22a87169a608d7f1b2aa1121e52bdd70.svg";
export { ForwardRef as ReactComponent };